import { Box } from "@mui/material";
import { type ForwardedRef, forwardRef, type Ref } from "react";
import { useTranslation } from "react-i18next";
import AmountsAndStatus, { SelfSchedulingStatus } from "./AmountsAndStatus";

type Props = {
	signupShiftsCurrentAmount?: number;
	signupShiftsTargetAmount?: number;
	ref?: Ref<HTMLDivElement>;
};

/**
 * SelfSchedulingMetrics component displays the signed up shifts metric
 * @param signupShiftsCurrentAmount - Current amount of signup shifts
 * @param signupShiftsTargetAmount - Target amount of signup shifts based on employment type
 * @param ref - Optional ref to attach to the component
 */
const SelfSchedulingMetrics = forwardRef<HTMLDivElement, Props>(
	({ signupShiftsCurrentAmount = 0, signupShiftsTargetAmount = 0 }, ref: ForwardedRef<HTMLDivElement>) => {
		const { t } = useTranslation();
		return (
			<Box ref={ref} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<AmountsAndStatus
					label={t("signed.up")}
					status={
						signupShiftsTargetAmount === 0
							? SelfSchedulingStatus.Optional
							: signupShiftsCurrentAmount >= signupShiftsTargetAmount
								? SelfSchedulingStatus.Done
								: SelfSchedulingStatus.Missing
					}
					currentAmount={signupShiftsCurrentAmount}
					maxAmount={signupShiftsTargetAmount}
				/>
			</Box>
		);
	},
);

// Give the component a name (for debugging tools)
SelfSchedulingMetrics.displayName = "SelfSchedulingMetrics";

export default SelfSchedulingMetrics;
